module.exports = __webpack_public_path__ + "static/media/6.e7d7660e.jpg";